import React from 'react';
import { MessageCircle } from 'lucide-react';
import './css/whatsapp-button.css';

const WhatsAppButton = () => {
  const phoneNumber = '+966573394229';
  const message = encodeURIComponent('مرحباً، أود الاستفسار عن خدمات نبض كير.');
  const cleanNumber = phoneNumber.replace('+', '');
  const link = `https://wa.me/${cleanNumber}?text=${message}`;

  return (
    <a
      href={link}
      className="whatsapp-floating-btn"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="تواصل عبر واتساب"
    >
        <i className="lab la-whatsapp"></i>
    </a>
  );
};

export default WhatsAppButton;

